/*
 * Module for wrapping and initializing our "pretty" scrollbars ala PerfectScrollbar
 */

rs.module("common/perfect-scrollbar", [], function () {

    //
    // Initialize pretty scrolling for the given element. The PerfectScrollbar instance
    // that manages the scrolling is returned
    function createInstance(element, options = {}) {

        var ps = new PerfectScrollbar(element.jquery ? element.get(0) : element, options);
        
        // The PerfectScrollbar doesn't update itself when the container changes.  Instead of trying
        // to track resizes we take advantage of the fact that the scrollbar isn't visible unless
        // the mouse is over it, and update it just in time when the mouse enters.  The negative
        // side-effect is that due to the way the update is done any css transitions defined going
        // from the base to hover state are effected instantly (so no nice fade-in)
        $(element).on("mouseenter", function () { ps.update(); });

        // We don't want scrolling, once we've reached the "edge", to start scrolling the parent.  It's weird
        // to be scrolling our site menu for example, reach the end, and then watch the body behind it start to scroll
        $(element).preventScrollPropogation();

        return ps;
    }

    var exports = {
        createInstance: createInstance
    };
 
    return exports;
});